import { PropsWithChildren } from 'react'
import { useRouteError } from 'react-router'

import { Alert, Button } from 'antd'
import { createStyles } from 'antd-style'

const useStyles = createStyles(({ token }) => ({
  message: {
    marginBlock: token.marginMD
  }
}))

export const ErrorBoundary = ({ children }: PropsWithChildren) => {
  const { styles } = useStyles()
  const error = useRouteError()

  if (error) {
    if (
      error instanceof Error &&
      error.message.includes('Failed to fetch dynamically imported module')
    ) {
      return (
        <Alert
          showIcon
          className={styles.message}
          description='页面资源已变更，请刷新页面'
          title='系统升级'
          type='warning'
          action={
            <Button
              type='primary'
              onClick={() => {
                window.location.reload()
              }}
            >
              刷新
            </Button>
          }
        />
      )
    }
    return (
      <Alert
        showIcon
        className={styles.message}
        title='系统异常'
        type='warning'
        description={
          typeof error === 'object' && 'message' in error
            ? error.message
            : (error as any)
        }
      />
    )
  }

  return <Alert.ErrorBoundary>{children}</Alert.ErrorBoundary>
}
